"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTemplate = void 0;
/* eslint-disable require-jsdoc */
const types_1 = require("../main/types");
class CardTemplate extends types_1.CardTemplateType {
}
exports.CardTemplate = CardTemplate;
CardTemplate.converter = {
    toFirestore(data) {
        return {
            moduleId: data.moduleId,
            submoduleId: data.submoduleId,
            elementId: data.elementId,
            siblingId: data.siblingId,
            random: data.random,
            cardQuestion: data.cardQuestion,
            cardAnswer: data.cardAnswer,
            gameplayInfo: data.gameplayInfo,
            conceptInfo: data.conceptInfo,
            spacedRepInfo: data.spacedRepInfo,
            diagram: data.diagram
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const moduleId = documentData.moduleId;
        const submoduleId = documentData.submoduleId;
        const elementId = documentData.elementId;
        const siblingId = documentData.siblingId;
        const random = documentData.random;
        const cardQuestion = documentData.cardQuestion;
        const cardAnswer = documentData.cardAnswer;
        const gameplayInfo = documentData.gameplayInfo;
        const conceptInfo = documentData.conceptInfo;
        const spacedRepInfo = documentData.spacedRepInfo;
        const diagram = documentData.diagram;
        const data = new CardTemplate(id, moduleId, submoduleId, elementId, siblingId, cardQuestion, cardAnswer, gameplayInfo, conceptInfo, spacedRepInfo, diagram);
        data.random = random;
        return data;
    }
};
